import MoneyMask from "Components/MoneyMask/MoneyMask";

function getGridItems(items) {
    if (items && items.length > 0) {
        const sortedItems = items[0].sumAllCostVO.sort((a, b) => a.idSequence - b.idSequence);
        const gridItems = sortedItems.map(element => (
            <div key={element.id} order={element.idSequence} className="cell">
                {element.dsItem}
            </div>
        ));

        return gridItems;
    } else {
        return null;
    }
}

function getValueToShow(item, element) {
    if (element.id === 1 && item.descriptionMonth) {
        return item.descriptionMonth;
    } else if (element.id === 2) {
        return item.sumExpectedValue;
    } else if (element.id === 3) {
        return item.sumRealValue;
    } else {
        return element.realValue;
    }
}

function getColorValueToShow(item, element) {
    if (![1, 2].includes(element.id) && (element.colorCode === 0 || (item.colorCode === 0 && [3].includes(element.id)))) {
        return 'rgb(128 0 128)';
    } else if (![1, 2].includes(element.id) && (element.colorCode === 1 || (item.colorCode === 1 && [3].includes(element.id)))) {
        return 'rgb(5 154 35)'
    } else if (![1, 2].includes(element.id) && (element.colorCode === 2 || (item.colorCode === 2 && [3].includes(element.id)))) {
        return 'rgb(255 26 9)'
    } else {
        return 'rgb(0 0 0)'
    }
}

function getValuesItems(items) {
    let itemsGrid = null;

    if (items && items.length > 0) {
        itemsGrid = []
        items.forEach((item) => {
            const rowValues = [];
            const sortedElements = item.sumAllCostVO.sort((a, b) => a.idSequence - b.idSequence);
            sortedElements.forEach((element) => {
                const entry = {
                    id: element.id,
                    value: MoneyMask.validateMoneyMask(getValueToShow(item, element)),
                    color: getColorValueToShow(item, element),
                    currentMonth: item.currentMonth,
                    indexId: element.indexId,
                    balloonValue: element.expectedValue,
                    millisecondsToShowValue: 2000
                };
                rowValues.push(entry);
            });

            itemsGrid.push(rowValues);
        });
    }
    return itemsGrid;
}

export default { getGridItems, getValuesItems };
